import React, {Component} from "react";
import axios from "axios";
import {_Home1} from "../components/_Home1";
import { Service } from "../components/Service";
import { Temoignage } from "../components/Temoignage";
import { Portfolio } from "../components/Portfolio";
import { Contact } from "../components/Contact";
import { Information } from "../components/Information";
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import "../assets/css/dashboard.css";

const sameId = (left, right) => left != null && right != null && String(left) === String(right);
const isVisibleArticle = (article) => String(article?.comment) !== "3";
const isServiceArticle = (article) => String(article?.comment) === "3";
const isInCategory = (article, categoryId) =>
    sameId(article?.category?.id, categoryId) || sameId(article?.category?.parentId, categoryId);

const DashboardHighlights = ({ articles = [], categories = [], teams = [] }) => {
    const stats = [
        {
            icon: "bi bi-broadcast-pin",
            value: articles.length || "24/7",
            label: "Actualité suivie",
            text: "Une veille permanente pour identifier, traiter et diffuser les sujets qui comptent.",
        },
        {
            icon: "bi bi-kanban",
            value: categories.length || "360°",
            label: "Lignes éditoriales",
            text: "Des rubriques structurées pour informer, expliquer, divertir et valoriser les initiatives.",
        },
        {
            icon: "bi bi-camera-video",
            value: teams.length || "Live",
            label: "Production terrain",
            text: "Reportages, interviews, captation vidéo et contenus prêts pour la diffusion digitale.",
        },
        {
            icon: "bi bi-send-check",
            value: "Digital",
            label: "Diffusion rapide",
            text: "Des contenus optimisés pour le web, les réseaux sociaux et les campagnes médias.",
        },
    ];

    return (
        <section className="dashboard-studio" aria-label="Approche multimédia B-Eye Group">
            <div className="container">
                <div className="row align-items-end gy-4 dashboard-studio__top">
                    <div className="col-lg-7" data-aos="fade-right">
                        <span className="dashboard-kicker">B-Eye Media Studio</span>
                        <h2>
                            Une présence média plus forte : stratégie, image, contenu et diffusion.
                        </h2>
                    </div>

                    <div className="col-lg-5" data-aos="fade-left" data-aos-delay="100">
                        <p>
                            B-Eye Group accompagne les marques, institutions et personnalités dans la
                            création de contenus modernes, impactants et adaptés aux nouveaux usages digitaux.
                        </p>
                    </div>
                </div>

                <div className="dashboard-studio__grid">
                    <div className="dashboard-studio__feature" data-aos="zoom-in">
                        <div>
                            <span className="dashboard-studio__label">Méthode B-Eye</span>
                            <h3>
                                De l’idée à la diffusion, chaque contenu est pensé pour capter l’attention
                                et renforcer votre image.
                            </h3>
                        </div>

                        <a href="#contact" className="dashboard-mini-link">
                            Lancer un projet <i className="bi bi-arrow-right"></i>
                        </a>
                    </div>

                    {stats.map((item, index) => (
                        <div
                            className="dashboard-stat"
                            key={item.label}
                            data-aos="fade-up"
                            data-aos-delay={(index + 1) * 90}
                        >
                            <i className={item.icon}></i>
                            <strong>{item.value}</strong>
                            <span>{item.label}</span>
                            <p>{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};


    const DashboardExperience = () => {
        const steps = [
            {
            icon: "bi bi-camera-reels",
            title: "Créer des contenus qui captivent",
            text: "Vidéographie, photographie et production d'émissions conçues pour raconter votre histoire, renforcer votre image de marque et créer un impact durable auprès de votre audience."
            },
            {
            icon: "bi bi-megaphone",
            title: "Diffuser et développer votre audience",
            text: "Marketing digital, réseaux sociaux et campagnes de communication pour accroître votre visibilité, générer de l'engagement et atteindre vos objectifs."
            }
        ];

        return (
        <section className="dashboard-experience" aria-label="Expertise B-Eye Group">
            <div className="container">
                <div className="dashboard-experience__panel" data-aos="fade-up">
                    <div className="dashboard-experience__intro">
                        <span className="dashboard-kicker">Notre expertise</span>

                        <h2>Votre histoire mérite d'être vue et entendue.</h2>

                        <p>
                            De la vidéographie au marketing digital, nous créons des contenus qui captivent l'attention, 
                            renforcent votre crédibilité et développent votre audience
                        </p>
                    </div>

                    <div className="dashboard-experience__steps">
                        {steps.map((step, index) => (
                            <div
                                className="dashboard-step"
                                key={step.title}
                                data-aos="fade-up"
                                data-aos-delay={(index + 1) * 100}
                            >
                                <span>{String(index + 1).padStart(2, "0")}</span>

                                <i className={step.icon}></i>

                                <h3>{step.title}</h3>

                                <p>{step.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
        );
    };


class Dashboard extends Component{

    state = {
        teams : [],
        articles : [],
        categories : [],
    }

    async getArticles (){
        let articles = await axios.get('articles')
        if(articles.status === 200){
            this.setState({ articles : articles.data })
        }
    }

    async getTeams (){
        let users = await axios.get('/teams')
        if(users.status === 200){
            this.setState({ teams : users.data })
        }
    }

    async getCategories (){
        let categories = await axios.get('categories')
        if(categories.status === 200){
            this.setState({ categories : categories.data })
        }
    }

    componentDidMount(){
        this.getTeams()
        this.getArticles()
        this.getCategories()
        this.refreshToken()
        var country = localStorage.getItem("country") ?  JSON.parse(localStorage.getItem("country")) : {};
       
        
        if(!country.country)
            this.datacountryIp();

        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async refreshToken () {
        try{
          var token = await axios.get('token');
          if(token.status === 200)
          {
              var user = (token.data.data);
              localStorage.setItem("user", JSON.stringify(user));
          }
          else if(token.status === 401)
          {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
          }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
        }
    }

    async datacountryIp(){
        try{
            var ip = await axios("https://httpbin.org/ip");
            if(ip.status === 200)
            {
                var country = await axios.get('country/' + ip.data.origin);
                if(country.status === 200)
                {
                    localStorage.setItem("country", JSON.stringify(country.data) );
                }
            }
        }catch(error){
            console.log(error);
        }
    }
    

    render(){
        const articles = [...this.state.articles];
        const latestArticles = [...articles]
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .filter(isVisibleArticle);
        const informationArticles = latestArticles
            .filter((article) => isInCategory(article, process.env.REACT_APP_ID_INFOROMATION))
            .slice(0, 14);
        const serviceArticles = articles.filter(
            (article) => isServiceArticle(article) && isInCategory(article, process.env.REACT_APP_ID_SERVICE)
        );
        const portfolioArticles = articles
            .filter((article) => isVisibleArticle(article) && isInCategory(article, process.env.REACT_APP_ID_SERVICE))
            .slice(0, 9);
        const childCategories = this.state.categories.filter((category) => category.parentId != null);

        return(
            <>
                <_Home1 />
                <main id="main" className="dashboard-main">
                    <DashboardHighlights articles={articles} categories={this.state.categories} teams={this.state.teams} />
                    <DashboardExperience />
                    <Information articles={ informationArticles } articleLast={ latestArticles.slice(0, 7) } categories={ this.state.categories } />
                    <Service articles={ serviceArticles } />
                    <Portfolio  articles={ portfolioArticles } categories={childCategories} />
                    <Temoignage />
                    <Contact />
                    
                    <div>
                        <FloatingWhatsApp 
                            phoneNumber={'+25762402554'}
                            accountName={ 'B-eyeGroup' }
                            avatar={ 'https://b-eyegroup.net/img/v3.png'}
                            chatMessage ={'B-eye pret pour vous servir!'}
                            placeholder = "type text..."
                            statusMessage = { 'Service multimédia' }
                            buttonStyle={{ height:40+"px", width:40+"px", padding : 0 +"px", margin: 0 +"px"}}
                        />
                    </div>
                    
                </main> 
            </>
        )
    }
}
export default Dashboard;
